$(window).on("load", function() {
  
/* Gsap */
if ($("body").hasClass("collection_page")) {
  var numItems = $('#product-grid li').length;
  if(numItems < 4){
    $('.grid-wrapper').addClass('less-elements');
  }
 // console.log(numItems);
}
$('body').on('click', '.mobile-facets__list li', function() {
  setTimeout(function(){
  var numItems = $('#product-grid li').length;
    if(numItems < 4){
      $('.grid-wrapper').addClass('less-elements');
    }
   // console.log(numItems);
  },2000); 
  
});

$('body').on('click', '.inputs_group', function() {

  $(this).addClass('float');
});

  $( "#mc_embed_signup_scroll" ).on( "mouseleave", function() {

  $('.inputs_group').removeClass('float');
} );

  $('#horns').change(function() {
        if(this.checked) {
            $('#mc-embedded-subscribe').removeAttr("disabled");
        }else{
          $('#mc-embedded-subscribe').prop("disabled", true);
        }     
    });
/* Sticky header */



let background_1 = "linear-gradient(rgb(255, 255, 255) 24%, rgba(255, 255, 255, 0.73) 100%, rgba(255, 255, 255, 0) 100%)";
const showAnim = gsap.from('.header-wrapper', { 
    background: background_1,
    paused: true,
    duration: 0.6
  }).progress(1);
  
  ScrollTrigger.create({
    start: "top top",
    end: 99999,
    
    onEnter: function() { 
    //  showAnim.reverse();
      $('.mobile_menu').addClass('menuColorActive');
      $('.header__heading-link .h2').addClass('textColorActive');
      $('.header__heading-link').addClass('textColorActive_top');
    },
    onLeaveBack: function() { 
     // showAnim.play();
      $('.mobile_menu').removeClass('menuColorActive');
      $('.header__heading-link .h2').removeClass('textColorActive');
      $('.header__heading-link').removeClass('textColorActive_top');
    }
  });


});

$( document ).ready(function() {
  
    console.log( "Ok all is ready!" );
    $('body').on('click', '.submenu-open li a', function() {
      console.log('Chiudo il menu');
      $("li details").removeClass('menu-opening');
      $("ul").removeClass('submenu-open');
    });


  $('body').on('click', 'li.li_Active', function() {
      console.log('Chiudo tutti i sottomenu');
      $('.li_Active details').removeClass('menu-opening');
      $('.li_Active details').removeClass('single-menu-opening');
      console.log('Rimuovo attributo');
      $(this).find('details').addClass('menu-opening');
      $(this).find('details').addClass('single-menu-opening');
      console.log('Fine Rimuovo attributo');
    $active_link = $(this).find('details');
   setTimeout(
  function() 
  {
    $(".li_Active details").removeAttr('open');
    console.log('Rimuovo attributo');
    $active_link.attr('open',true);
    console.log('ri assegno attributo');
  }, 300);
  });
    
    
    $("#SortBy option:selected").each(function () {
      $(this).removeAttr('selected'); 
      });
      $('#SortBy').append($('<option>', {
          value: 1,
          text: 'Ordina per:'
      }));
      $("#SortBy option").each(function(){
        if ($(this).text() == "Ordina per:")
          $(this).attr("selected","selected");
      });

    checkforsectionactive();
    /* Animazioni menu */
    var $closemenu_animation = $('.menu-drawer__navigation');
    var $check_situation = $('#Details-menu-drawer-container');
    /* Aggiungo una classa alla fine dell'anmazionedi entrata */
    $closemenu_animation.on('webkitTransitionEnd', function(e) {
        $check_situation.addClass('animation_out');
    });
    /* Rimuovo la classe alla fine dell'animazione d'uscita */
    $('body').on('click', '#Details-menu-drawer-container', function() {
   //   console.log('click on nav');
        const mydivclass = document.getElementsByClassName('menu-open');
        if (mydivclass.length == 0) {
            setTimeout(function() {
                $check_situation.removeClass('animation_out');
            }, 1200);
        }else{
          var $cards_li = $('#menu-drawer .list-menu li');
          var time = 200;
        //  console.log('Rendiamo visibili i links');
          $cards_li.each(function(index) {
           // console.log('li');
           // console.log(index);
            // $(this).delay(500*index).addClass('li_Active');
            setTimeout(() => { 
              $(this).addClass('li_Active');
             }, index * time);
          });
     //     console.log('menu aperto');
        }
    });
   

  /* ************************************************************** */
    /**** Check if element with class 'fadeOnScreen' is in viewport */
    /************************************************************** */

    /********************* 1° Function for check if lement is in viewport */


      $(window).on('resize scroll', function() {
        checkforsectionactive();
      });

      function checkforsectionactive(){
        $('.section').each(function() {
          var top_of_element = $(this).offset().top;
          var bottom_of_element = $(this).offset().top + $(this).outerHeight();
          var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
          var top_of_screen = $(window).scrollTop();

          if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
            $(this).addClass('section__active');
            if ($(this).has('.product-card-wrapper').length) {
              $(this).addClass('section__product-card-wrapper__active');
            }
            if ($(this).has('.image-with-text').length) {
              $(this).addClass('image-with-text__active');
            }
          } else {
            $(this).removeClass('section__active');
            if ($(this).has('.product-card-wrapper').length) {
              $(this).removeClass('section__product-card-wrapper__active');
            }
            if ($(this).has('.image-with-text').length) {
              $(this).removeClass('image-with-text__active');
            }
          }
        });
      }


  $('body').on('click', '.banner_with_image_back', function() {
      var href = $('.banner__buttons .button').attr('href');
      window.location.href = href;
      console.log(href);
    });

  $('body').on('click', '#Banner-template--16943521104177__4202c769-31ac-424f-8bfc-e9cee3788bd3', function() {
      var href = $('#Banner-template--16943521104177__4202c769-31ac-424f-8bfc-e9cee3788bd3 .banner__buttons .button').attr('href');
      window.location.href = href;
      console.log(href);
    });
      
});



